module.exports = __webpack_public_path__ + "fonts/ProximaNovaW05-Semibold.a7bb0548.ttf";